module.exports = __webpack_public_path__ + "img/login-v2-dark.d63bb1c5.svg";